import { SuperAdminSignalementsPage } from "../../operator/console/super-admin-signalements";

export default function ConsoleSuperAdminSignalements() {
  return <SuperAdminSignalementsPage />;
}
